import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { TabelaPrecoService } from 'src/app/services/http/tabela-preco.service';
import { first } from 'rxjs/operators';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'app-form-tabela-preco-laudo',
  templateUrl: './form-tabela-preco-laudo.component.html',
  styleUrls: ['./form-tabela-preco-laudo.component.scss']
})
export class FormTabelaPrecoLaudoComponent implements OnInit {

  form = new FormGroup({
    nome: new FormControl('', [Validators.required]),
    descricao: new FormControl('', [Validators.required]),
  });

  id: any = null;
  uuid: any = null;

  listaLaudo: { cortesia: boolean, nomeTipoLaudo: string, range: FormGroup[], id: null }[] = [];

  listaLaudoCombinado: { cortesia: boolean, nomeTipoLaudo: string, range: FormGroup[], id: null }[] = [];
  tabelaPadrao: boolean;
  desativarInputsEBotoes: boolean = false;

  constructor(
    private router: Router,
    private activedRoute: ActivatedRoute,
    private msgModal: ModalMsgService,
    private tabelaPrecoService: TabelaPrecoService) {
    this.activedRoute.params.pipe(first()).subscribe(r => this.uuid = r.uuid || null);
    this.tabelaPadrao = this.activedRoute.snapshot.data.padrao;
    try{
      if ( this.activedRoute.snapshot.data['desativarInputsEBotoes'] === true ) {
          this.desativarInputsEBotoes = this.activedRoute.snapshot.data['desativarInputsEBotoes'];
      }
    } catch (e) {
      console.log(e.stack);
    }
  }

  ngOnInit() {

    if(this.tabelaPadrao) {
      this.tabelaPrecoService.getTabelaPadraoLaudo()
      .then( r => {
        this.id = r.id
        this.getTabelaPreco();
      } )
    } else if (this.uuid) {
      this.getTabelaPreco();
    } else {
      this.tabelaPrecoService.getListaTipoLaudoCombinado().then(r => this.listaLaudoCombinado = r.map(i => ({
        id: i.id,
        nomeTipoLaudo: i.nome,
        cortesia: i.cortesia,
        range: [this.addRangeItem()]
      })));

      this.tabelaPrecoService.getListaTipoLaudo().then(r => this.listaLaudo = r.map(i => ({
        id: i.id,
        nomeTipoLaudo: i.nome,
        cortesia: i.cortesia,
        range: [this.addRangeItem()]
      })))
    }
  }

  addRangeItem(valor: string | number = '', min = 1, id = null) {
    if (typeof valor == 'number') {
      valor = Utils.numberToString(valor)
    }

    return new FormGroup({
      valorConsulta: new FormControl(valor, [Validators.required]),
      min: new FormControl(min, [Validators.required]),
      id: new FormControl(id),
    });
  }

  getTabelaPreco() {
    this.tabelaPrecoService.getTabelaPrecoLaudo(this.uuid).then(t => {
      this.form.patchValue({
        nome: t.nome,
        descricao: t.descricao
      });

      t.listaValorTipoLaudo.forEach(l => {
        this.listaLaudo.push({
          id: l.id || null,
          nomeTipoLaudo: l.nomeTipoLaudo,
          cortesia: l.cortesia,
          range: l.listrange.map(item => this.addRangeItem(item.valor, item.rangeMin, item.id))
        });
      });

      t.listaValorLaudoCombinado.forEach(l => {
        this.listaLaudoCombinado.push({
          id: l.id || null,
          cortesia: l.cortesia,
          nomeTipoLaudo: l.nomeTipoLaudo,
          range: l.listrange.map(item => this.addRangeItem(item.valor, item.rangeMin, item.id))
        });
      });

    });
  }


  errorValidate() {
    let errorCount = 0;

    this.listaLaudo.forEach(c => {
      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          r.controls.valorConsulta.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }
    });

    this.listaLaudoCombinado.forEach(c => {
      if (!c.cortesia) {
        c.range.forEach(r => {
          r.controls.min.markAsTouched();
          r.controls.valorConsulta.markAsTouched();
          if (r.invalid) {
            errorCount++;
          }
        })
      }
    });

    if (errorCount > 0 || this.form.invalid) {

      for (const k in this.form.controls) {
        if (this.form.controls.hasOwnProperty(k)) {
          this.form.controls[k].markAsTouched();
        }
      }
      this.msgModal.openDialog('Formulario inválido', 'Preencha todos os campos corretamente', 'danger');
      return true;
    } else {
      return false;
    }
  }

  formatRange(range) {
    let listrange = [];

    for (let i = 0; i < range.length; i++) {
      const min = range[i].controls.min.value;
      const value = Utils.stringToNumber(range[i].controls.valorConsulta.value);
      let max = null;
      if (i < range.length - 1) {
        max = range[i + 1].controls.min.value - 1;
      }

      if (range[i].controls.id && range[i].controls.id.value) {
        let id = range[i].controls.id.value;
        listrange.push({ min: min, precoPersonalizado: value, max: max, id: id });
      } else {
        listrange.push({ min: min, precoPersonalizado: value, max: max });
      }
    }
    return listrange;
  }

  formatJson() {

    let json = {
      listaValorLaudo: [],
      listaValorLaudoCombinado: [],
      tabelaPadrao: this.tabelaPadrao,
      tabelaPreco: {
        id: this.id,
        nome: this.form.controls.nome.value,
        descricao: this.form.controls.descricao.value,
      }
    };

    this.listaLaudo.forEach(c => {
      json.listaValorLaudo.push({ id: c.id, cortesia: c.cortesia, nome: c.nomeTipoLaudo, listrange: this.formatRange(c.range) });
    });

    this.listaLaudoCombinado.forEach(c => {
      json.listaValorLaudoCombinado.push({ id: c.id, cortesia: c.cortesia, nome: c.nomeTipoLaudo, listrange: this.formatRange(c.range) });
    });

    return json;
  }

  confirmar() {

    if (this.errorValidate()) {
      return;
    } else if (this.id) {
      this.tabelaPrecoService.alterarTabelaPrecoLaudo(this.formatJson()).then(r => {
        this.router.navigate(['tabela-preco','laudo','listar']);
      });
    } else {
      this.tabelaPrecoService.cadastrarTabelaPrecoLaudo(this.formatJson()).then(r => {
        this.router.navigate(['tabela-preco','laudo','listar']);
      });
    }

  }



}
